import { ConversationDetail } from '../interface/conversation.interface';

/** Convert a Date, ISO string, or Firestore Timestamp-like value to epoch milliseconds. */
export function toEpochMs(value: unknown): number {
  if (!value) return 0;
  if (value instanceof Date) return value.getTime();
  if (typeof value === 'number') return value;
  return new Date(value as string).getTime();
}

/** Sort conversations by latestRelevantActivityTime descending (newest first). */
export function sortByActivity(conversations: ConversationDetail[]): ConversationDetail[] {
  return [...conversations].sort((a, b) => {
    const aTime = toEpochMs((a.conversation as any)?.latestRelevantActivityTime);
    const bTime = toEpochMs((b.conversation as any)?.latestRelevantActivityTime);
    return bTime - aTime;
  });
}
